import cn from 'classnames';
import React from 'react';
import { DeviceType } from '@wix/cashier-common/dist/src/enums/DeviceType';
import { DH } from '../../../../utils/DataHook';
import { t } from '../../../../utils/i18n';
import { AriaNode } from '../../../CardsList/elements/AriaNode';
import { IFetchCardsErrorMessageConnectedProps } from './view.connect';
import s from './styles.scss';

export const FetchCardsErrorMessage: React.FC<IFetchCardsErrorMessageConnectedProps> = (props) => (
  <section
    data-hook={DH.Error.Fetch.Container}
    className={cn(s.fetchCardsErrorMessage, {
      [s.desktop]: props.deviceType === DeviceType.Desktop,
      [s.mobile]: props.deviceType === DeviceType.Mobile,
    })}
  >
    <div role="heading" tabIndex={0}>
      {t('app.fetch-cards.error')}
    </div>

    <AriaNode role="button" data-hook={DH.Error.Fetch.Retry} onClick={props.fetchCards}>
      {t('app.fetch-cards.error.retry')}
    </AriaNode>
  </section>
);
FetchCardsErrorMessage.displayName = 'FetchCardsErrorMessage';
